import { StatesDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllStatesResponseModel extends GlobalResponseObject {
    data?: StatesDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: StatesDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

